import axios from 'axios'
import { Message } from 'element-ui'

const request = axios.create({
  baseURL: '/api',
  timeout: 15000,
  headers: { 'Content-Type': 'application/json' }
})

// 请求拦截：自动带 token
request.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

// 响应拦截：统一处理错误
request.interceptors.response.use(
  res => res.data,
  err => {
    const status = err?.response?.status
    const msg =
      err?.response?.data?.detail ||
      err?.response?.data?.message ||
      err?.response?.data?.msg ||
      err?.message ||
      '请求失败'

    // 401：token 失效/未登录
    if (status === 401) {
      localStorage.removeItem('access_token')
      localStorage.removeItem('admin_info')
      Message.error('登录已失效，请重新登录')
      // 这里不要直接 import router，避免循环依赖，简单跳转：
      if (location.hash !== '#/login') location.href = '#/login'
      return Promise.reject(err)
    }

    Message.error(msg)
    return Promise.reject(err)
  }
)

export default request